import { useState, useEffect, useCallback } from 'react';
import { CarouselApi } from 'types/sharedComponents';

const useCarousel = () => {
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);
  const [snapCount, setSnapCount] = useState(0);

  useEffect(() => {
    if (!api) return;

    const handleSelect = () => {
      setCurrent(api.selectedScrollSnap());
      setSnapCount(api.scrollSnapList().length);

      const autoplay = api?.plugins()?.autoplay;
      if (autoplay?.isPlaying()) {
        autoplay.reset();
      }
    };

    const handleReInit = () => {
      setCurrent(api.selectedScrollSnap());
      setSnapCount(api.scrollSnapList().length);
    };

    handleReInit();
    api.on('select', handleSelect);
    api.on('reInit', handleReInit);

    return () => {
      api.off('select', handleSelect);
      api.off('reInit', handleReInit);
    };
  }, [api]);

  const scrollTo = useCallback(
    (index: number) => {
      api?.scrollTo(index);
    },
    [api],
  );

  return { current, snapCount, scrollTo, setApi };
};

export default useCarousel;
